import { Outlet } from "react-router-dom";

import { Footer } from "../components/Footer";
import { AccountNav } from "../navs/AccountNav";

export const AccountContainer = () => {
  return (
    <div className="navContentContainer">
      <nav className="blueNavBar">
        <AccountNav />
      </nav>
      <div className="mainContent">
        <div className="container">
          <Outlet></Outlet>
        </div>
        <Footer></Footer>
      </div>
    </div>
  );
};
